/**
 * Notification type constants
 * These constants define the different types of notifications used throughout the application.
 * They should match the NOTIFICATION_TYPES defined in the backend constants.
 */

export const NOTIFICATION_TYPES = {
  // Teaching-related notifications
  NEW_TEACHING: "newTeaching",
  TEACHING_REQUEST: "teachingRequest",
  TEACHING_REQUEST_ANSWER: "teachingRequestAnswer",

  // Content-related notifications (currently commented out in backend but used in frontend)
  NEW_VIDEO: "newVideo",
  NEW_QUESTION: "newQuestion",
  NEW_LINK: "newLink",
  NEW_GROUP: "newGroup",
  NEW_QUESTION_ANSWER: "newQuestionAnswer",
  NEW_CONTENT_ANSWER: "newContentAnswer",
};

/**
 * Helper function to check if a notification type is a teaching-related notification
 * @param {string} notificationType - The notification type to check
 * @returns {boolean} True if the notification type is teaching-related
 */
export const isTeachingNotification = (notificationType) => {
  return [
    NOTIFICATION_TYPES.NEW_TEACHING,
    NOTIFICATION_TYPES.TEACHING_REQUEST,
    NOTIFICATION_TYPES.TEACHING_REQUEST_ANSWER,
  ].includes(notificationType);
};

/**
 * Helper function to check if a notification type is a chat-based notification
 * (opens chat instead of navigating to a content page)
 * @param {string} notificationType - The notification type to check
 * @returns {boolean} True if the notification type opens chat
 */
export const isChatNotification = (notificationType) => {
  return [
    NOTIFICATION_TYPES.TEACHING_REQUEST,
    NOTIFICATION_TYPES.TEACHING_REQUEST_ANSWER,
  ].includes(notificationType);
};

/**
 * Helper function to check if a notification type is a content-based notification
 * @param {string} notificationType - The notification type to check
 * @returns {boolean} True if the notification type is content-related
 */
export const isContentNotification = (notificationType) => {
  return [
    NOTIFICATION_TYPES.NEW_VIDEO,
    NOTIFICATION_TYPES.NEW_QUESTION,
    NOTIFICATION_TYPES.NEW_LINK,
    NOTIFICATION_TYPES.NEW_GROUP,
    NOTIFICATION_TYPES.NEW_QUESTION_ANSWER,
    NOTIFICATION_TYPES.NEW_CONTENT_ANSWER,
  ].includes(notificationType);
};
